(function () {

  const SHOP_NUMERIC_ID = "92143943969"; 

  const API_URL     = "https://backend.cleansweeps.app/graphql";
  const PLATFORM_ID = `gid://shopify/Shop/${SHOP_NUMERIC_ID}`;

  const QUERY = `
    query QuerySweepstakeDetailsByProductId(
      $platform: String!
      $platformId: String!
      $productIds: [String!]
    ) {
      sweepstakeDetailsByProductId(
        platform: $platform
        platformId: $platformId
        productIds: $productIds
      ) {
        id
        entryManagement
        productsAllowedByDefault
        bonusEntriesDefault
        scheduledBonusValue
        scheduledBonusActive
        isActive
        products(productIds: $productIds) {
          productId
          productAllowed
          productBonusEntries
          productMultiplier
        }
      }
    }
  `;

  function calcEntries(sw, productId, priceCents) {
    let em;
    try { em = JSON.parse(sw.entryManagement); } catch { return null; }

    const dollarSpent = parseFloat(em.dollarSpent) || 1;
    const entryPer    = parseFloat(em.entryPer)    || 1;
    const roundFn     = em.roundUp !== false ? Math.ceil : Math.floor;
    const subtotal    = roundFn(priceCents / 100);

    
    const effectiveEntryPer =
      sw.scheduledBonusActive && sw.scheduledBonusValue > 0
        ? sw.scheduledBonusValue
        : entryPer;

    
    const baseEntries = (effectiveEntryPer / dollarSpent) * subtotal;


    const row = (sw.products || []).find(p => p.productId === productId);

    if (!row) {
      
      if (!sw.productsAllowedByDefault) return null;
      return {
        entries    : roundFn(baseEntries) + (sw.bonusEntriesDefault || 0),
        multiplier : effectiveEntryPer > 1 ? effectiveEntryPer : null
      };
    }

    if (row.productAllowed === false) return null; 

    
    const mult        = parseFloat(row.productMultiplier) || 1;
    const displayMult = roundFn(effectiveEntryPer * mult);
    return {
      entries    : roundFn(baseEntries * mult) + (row.productBonusEntries || 0),
      multiplier : displayMult > 1 ? displayMult : null
    };
  }

  
  function renderBadge(card, result) {
   
    card.querySelectorAll(".cs-badge").forEach(el => el.remove());
    if (!result) return;

    const badge = document.createElement("div");
    badge.className = "cs-badge";
    badge.innerHTML =
      `<span class="cs-badge__entries">${result.entries.toLocaleString()} ENTRIES</span>` +
      (result.multiplier ? `<span class="cs-badge__mult">${result.multiplier}X</span>` : "");

   
    const priceEl =
      card.querySelector(".price__container") ||
      card.querySelector(".price")            ||
      card.querySelector(".card__price")      ||
      card.querySelector("[class*='price']");

    if (priceEl) priceEl.insertAdjacentElement("afterend", badge);
    else         card.appendChild(badge);
  }

  
  async function resolveCard(card) {
    const link = card.querySelector("a[href*='/products/']");
    if (!link) return null;

    const href   = link.getAttribute("href") || "";
    const handle = href.split("/products/")[1]?.split("?")[0]?.split("#")[0];
    if (!handle) return null;

    try {
      const res  = await fetch(`/products/${handle}.js`);
      const data = await res.json();
      return {
        card,
        productId : `gid://shopify/Product/${data.id}`,
        price     : data.price   // in cents
      };
    } catch {
      return null;
    }
  }

  
  async function init() {
   
    const cards = document.querySelectorAll(
      ".card-wrapper, .product-card-wrapper, li.grid__item"
    );
    if (!cards.length) return;


    const resolved = await Promise.all([...cards].map(resolveCard));
    const valid    = resolved.filter(Boolean);
    if (!valid.length) return;

    let swList;
    try {
      const res  = await fetch(API_URL, {
        method  : "POST",
        headers : { "Content-Type": "application/json" },
        body    : JSON.stringify({
          query     : QUERY,
          variables : {
            platform  : "Shopify",
            platformId: PLATFORM_ID,
            productIds: valid.map(v => v.productId)
          }
        })
      });
      const json = await res.json();
      if (json.errors) { console.warn("[CleanSweeps]", json.errors); return; }
      swList = json?.data?.sweepstakeDetailsByProductId;
    } catch (err) {
      console.warn("[CleanSweeps] API error:", err);
      return;
    }

    
    const sw = swList?.find(s => s.isActive) || swList?.[0];
    if (!sw) return;

   
    valid.forEach(({ card, productId, price }) =>
      renderBadge(card, calcEntries(sw, productId, price))
    );
  }

  
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();